// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"jk-z","hideOnMobile":"kk-z"};